/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import '../../components/Chat/index.scss';

import { getAllTemplatesBot } from '../../store/actions/template-bot';
import { setCurrentTemplateBotTesting } from '../../store/actions/new-bot';
import actions from '../../store/actions';
import Chat from '../../components/Chat/index';
import Header from '../../components/Header';
import NewBotActions from './Components/NewBotActions';
import NewBotTemplateList from './Components/NewBotTemplateList';
import Footer from '../../components/Footer2/index';

const NewBot = (props) => {
  const {
    templatesBot,
    previewBot,
    currentTemplateBotTesting,
    setCurrentTemplateBotTesting,
  } = props;
  const [originalTemplateBots, setOriginalTemplateBots] = useState(
    templatesBot
  );
  const [currentTemplateList, setCurrentTemplateList] = useState(
    originalTemplateBots
  );
  const chatRef = useRef(null);

  useEffect(() => {
    const { getAllTemplatesBot } = props;
    getAllTemplatesBot();
  }, []);

  useEffect(() => {
    setOriginalTemplateBots(templatesBot);
  }, [templatesBot]);

  useEffect(() => {
    setCurrentTemplateList(originalTemplateBots);
  }, [originalTemplateBots]);

  useEffect(() => {
    const { visible } = previewBot;
    if (!visible) {
      closePreviewChat();
    }
  }, [previewBot.visible]);

  useEffect(() => {
    const { openPreviewBot } = props;
    const { isOpen } = currentTemplateBotTesting;
    if (isOpen) {
      openPreviewBot();
    }
  }, [currentTemplateBotTesting.isOpen]);

  const closePreviewChat = () => {
    setCurrentTemplateBotTesting({
      botId: '',
      isOpen: false,
    });
  };

  const renderTemplateBotTest = () => {
    const { botId, title } = currentTemplateBotTesting;
    if (botId === '') {
      return false;
    }

    return (
      <div id="bot-test-chat" className="chat">
        <Chat
          title={title}
          botId={botId}
          ref={chatRef}
          closePreviewChat={closePreviewChat}
        />
      </div>
    );
  };

  return (
    <div className="new-bot-main">
      <Header pagetype="page-inicio" />
      <div className="new-bot-content">
        <NewBotActions
          currentTemplateList={currentTemplateList}
          originalTemplateBots={originalTemplateBots}
          setCurrentTemplateList={setCurrentTemplateList}
        />
        <div className="new-bot-divider" />
        <NewBotTemplateList
          currentTemplateList={currentTemplateList}
          originalTemplateBots={originalTemplateBots}
          setOriginalTemplateBots={setOriginalTemplateBots}
          templatesBot={templatesBot}
          chatRef={chatRef}
        />
      </div>
      {renderTemplateBotTest()}
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    templatesBot: state.templateBot.allTemplateBots,
    previewBot: state.previewBot,
    currentTemplateBotTesting: state.newBot.currentTemplateBotTesting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { getAllTemplatesBot, ...actions.previewBot, setCurrentTemplateBotTesting },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBot);
